import { TRootState } from "../@types"

export const selectModalCoursesCategories = ( state: TRootState ) =>state.coursesCategories.coursesCategoriesModalIsOpen

export const selectIsUpdateCoursesCategories = ( state: TRootState ) =>state.coursesCategories.isUpdateCoursesCategories

export const selectCoursesCategoriesForUpdate = ( state: TRootState ) =>state.coursesCategories.coursesCategoriesForUpdate

export const selectCoursesCategoriesRefreshTable =  ( state: TRootState ) =>state.coursesCategories.refreshTableCoursesCategories